// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 分页查询 SKU 分期套餐列表 GET /api/v1/product-sku-installments */
export async function ProductSkuInstallmentControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSkuInstallmentControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputProductSkuInstallmentDtoArray>(
    "/api/v1/product-sku-installments",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 创建 SKU 分期套餐 POST /api/v1/product-sku-installments */
export async function ProductSkuInstallmentControllerCreateV1(
  body: MyApi.CreateProductSkuInstallmentDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputProductSkuInstallmentDto>(
    "/api/v1/product-sku-installments",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 查询 SKU 分期套餐详情 GET /api/v1/product-sku-installments/${param0} */
export async function ProductSkuInstallmentControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSkuInstallmentControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputProductSkuInstallmentDto>(
    `/api/v1/product-sku-installments/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新 SKU 分期套餐 PUT /api/v1/product-sku-installments/${param0} */
export async function ProductSkuInstallmentControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSkuInstallmentControllerUpdateV1Params,
  body: MyApi.UpdateProductSkuInstallmentDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputProductSkuInstallmentDto>(
    `/api/v1/product-sku-installments/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 删除 SKU 分期套餐（软删除） DELETE /api/v1/product-sku-installments/${param0} */
export async function ProductSkuInstallmentControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.ProductSkuInstallmentControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/product-sku-installments/${param0}`,
    {
      method: "DELETE",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
